export default "__VITE_ASSET__DXbQtQhV__"